<div class="page-breadcrumb p-t-20 p-b-20 p-l-30 p-r-30">
    <mat-toolbar>
        <ol class="breadcrumb">
            <li *ngFor="let breadcrumb of breadcrumbs">
                <span [routerLink]="breadcrumb?.url" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                {{ breadcrumb?.label }}
              </span>
            </li>
        </ol>
    </mat-toolbar>
</div>